import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "textarea-container" }
const _hoisted_2 = { class: "input-label mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-error"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "error-message"
}

import { useField, Field } from 'vee-validate';


export default {
  __name: 'ImportantInformationField',
  props: {
    isRequired: {
        type: Boolean,
        default: true,
    },
    title: {
        type: String,
        default: 'Dolegliwości i informacje dla Iekаrza',
    },
    placeholder: {
        type: String,
        default:
            'Prosimy o dokładne opisanie swoich dolegliwości, powód przyjmowania Ieku lub inne istotne informacje dla Iekаrza.',
    },
    classes: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props;



const { value, errors, errorMessage } = useField('importantInformation');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.title) + " ", 1),
      (__props.isRequired)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true),
      (!__props.isRequired)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(opcjonalne)"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Field), {
      as: "textarea",
      name: "importantInformation",
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
      type: "text",
      placeholder: __props.placeholder,
      class: _normalizeClass(["form-textarea", {
                'border-[1px] border-error border-solid': _unref(errors).length,
                'border-none': !_unref(errors).length,
                [__props.classes]: true,
            }])
    }, null, 8, ["modelValue", "placeholder", "class"]),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}